exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab[data-v-4fa57ee2]{display:block}", ""]);

// exports
